import moment from 'moment';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import { isExpiringSoon } from '../helper';
export var StatusColumn = function (_a) {
    var data = _a.data, onExtend = _a.onExtend;
    var handleExtend = function () {
        onExtend();
    };
    var isActionRequired = function () { return false; };
    if (isActionRequired()) {
        return React.createElement("span", null, "Action Required");
    }
    moment.relativeTimeThreshold('h', 26);
    return moment(data.expires).isAfter(moment()) ? (React.createElement("div", null,
        React.createElement("p", { style: { margin: 0 } }, data.status === 'PENDING' ? 'Launching' : 'Running'),
        React.createElement("p", { style: { fontSize: 12, margin: 0 }, className: "color-aluminum" },
            React.createElement(Popup, { position: "bottom center", inverted: true, trigger: React.createElement("span", null,
                    "Expires in about ",
                    moment().to(data.expires, true)) },
                React.createElement("span", { className: "font-x-small" }, moment(data.expires).format('D MMM @ h:mm a'))),
            isExpiringSoon(data.expires) && !data.hasExtended && (React.createElement("span", null,
                React.createElement("span", { className: "mx2" }, "\u00B7"),
                React.createElement("button", { type: "button", className: "uncolored-link-w-underline", onClick: handleExtend }, "Extend Now")))))) : (React.createElement(React.Fragment, null, "Expired"));
};
export default StatusColumn;
